import { render, staticRenderFns } from "./POIForm.vue?vue&type=template&id=3bcb082b&"
import script from "./POIForm.vue?vue&type=script&lang=js&"
export * from "./POIForm.vue?vue&type=script&lang=js&"
import style0 from "./POIForm.vue?vue&type=style&index=0&id=3bcb082b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports